import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="222397" id="shop-title" className="relative flex w-full flex-col items-center justify-center overflow-hidden bg-background py-24 md:py-32 lg:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-60" style={{
      backgroundImage: "radial-gradient(var(--primary) 1.5px, transparent 1.5px)",
      backgroundSize: "24px 24px"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 z-0 bg-background/20 bg-[radial-gradient(ellipse_at_center,transparent_20%,var(--background)_80%)]" />

      <div className="container relative z-10 flex flex-col items-center gap-6 px-4 text-center md:px-6">
        <h1 className="font-default text-5xl font-bold tracking-tight text-foreground uppercase md:text-7xl lg:text-8xl">
          All Collars
        </h1>

        <Breadcrumb>
          <BreadcrumbList className="justify-center sm:gap-3">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/HomePage" className="text-muted-foreground text-sm">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-muted-foreground" />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium text-muted-foreground text-sm">Shop</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </section>;
}